import React, { useState, useContext, useEffect, useRef } from 'react';
import { SelectDealFilter } from './SelectDealFilter';
import { DealSelectUsers } from './DealSelectUsers';
import { getIcon } from '../shared/field_inputs/shared/FormatHelpers';
import { DataContext as DealDataContext } from '../../../stores/crm-deal-store';
import { DataContext as SharedDataContext } from '../../../stores/crm-store';
import { DataContext as MainDataContext } from '../../../store';
import ReactDOM from 'react-dom';
import SpinLoader from '../shared/field_inputs/shared/SpinLoader';
import { FILTER_ITEM_ALLDEALS, FILTER_ITEM_MYDEALS, FILTER_ITEM_OWNER, FILTER_ITEM_PERSONALFILTERS, FILTER_ITEM_STATUS, FILTER_ITEM_USER } from '../../../i18n/keyConstants';
import { useTranslation } from 'react-i18next';

const FilterComponents = ({ type, t }) => {
    return (
        <>
            {type === 'CrmOrganizations' || type === 'CrmPersons' || type === 'CrmActivities' || type === 'CrmActiveDeals' ? (
                <DealSelectUsers />
            ) : null}
            {type === 'CrmDeals' || type === 'CrmAvailableConsultants' ? (
                <div>
                    <label>{t(FILTER_ITEM_OWNER)}</label>
                    <DealSelectUsers />
                    <hr className='form-hrule' />
                    <label>{t(FILTER_ITEM_STATUS)}</label>
                    <SelectDealFilter filterKey={'Status'} optionsName={'dealStatusOptions'} />
                    <label>{t(FILTER_ITEM_PERSONALFILTERS)}</label>
                    <SelectDealFilter filterKey={'Personal'} optionsName={'dealUserOptions'} />
                </div>
            ) : null}
        </>
    );
};

const DealFilterDropdown = ({ type }) => {
    const [isOpen, setIsOpen] = useState(false);

    const dropdown = useRef();
    const dropdownToggle = useRef();
    const { t } = useTranslation(['dealFilterDropDown']);

    const {
        store: { userFilterType, selectedUsersOptions, selectedUserGroupOption, selectedBossGroupOption, pipelines, currentPipelineId },
        dispatch: dealDispatch,
    } = useContext(DealDataContext);
    const { store: sharedStore } = useContext(SharedDataContext);
    const {
        store: { user: signedInUser },
    } = useContext(MainDataContext);

    useEffect(() => {
        dealDispatch({ type: 'SET_SELECTED_USERS_OPTIONS', payload: [{ id: signedInUser.crmUserId, name: signedInUser.name }] });
        dealDispatch({ type: 'SET_SELECTED_USER_GROUP_OPTION', payload: [] });
        dealDispatch({ type: 'SET_SELECTED_BOSS_GROUP_OPTION', payload: [] });
        dealDispatch({ type: 'SET_SELECTED_TEAM_GROUP_OPTION', payload: [] });
        dealDispatch({ type: 'SET_USER_FILTER_TYPE', payload: { id: 'user', name: t(FILTER_ITEM_USER), icon: 'user' } });

        document.addEventListener('click', handleClick, true);

        return () => {
            document.removeEventListener('click', handleClick, true);
        };
    }, []);

    const handleClick = (e) => {
        if (dropdown.current && dropdownToggle.current) {
            const dropdownToggleNode = ReactDOM.findDOMNode(dropdownToggle.current);
            const dropdownNode = ReactDOM.findDOMNode(dropdown.current);
            if (!dropdownNode.contains(e.target) && !dropdownToggleNode.contains(e.target)) {
                setIsOpen(false);
            }
        }
    };

    let filterIcon = getIcon(userFilterType.icon);
    let filterDescription = t(FILTER_ITEM_ALLDEALS);
    switch (userFilterType.id) {
        case 'user':
            if (!selectedUsersOptions) {
                // Empty filter
            } else if (selectedUsersOptions.length === 1) {
                const selectedUser = selectedUsersOptions[0];
                if (selectedUser.id === signedInUser.crmUserId) {
                    filterDescription = t(FILTER_ITEM_MYDEALS);
                } else {
                    filterDescription = selectedUser.name;
                }
            } else if (selectedUsersOptions.length > 1) {
                filterDescription = `${selectedUsersOptions.length} ${t(FILTER_ITEM_OWNER)})`;
            }
            break;
        case 'boss':
            if (selectedBossGroupOption?.users?.length > 0) {
                filterDescription = selectedBossGroupOption.name;
            }
            break;
        case 'group':
            if (selectedUserGroupOption?.users?.length > 0) {
                filterDescription = selectedUserGroupOption.name;
            }
            break;
        default:
            break;
    }
    // Set default filter icon if all deals are selected
    if (filterDescription === 'Allas deals') {
        filterIcon = getIcon('filter');
    }

    if (!sharedStore.areSelectOptionsFetched) {
        return <LoadingDealFilterDropdown t={t} />;
    }
    // TODO: Should be removed once data-window-fetch-refactor is complete by Anton
    /*if (!(pipelines[currentPipelineId]?.viewSettings && pipelines[currentPipelineId]?.filterOptions)) {
        return <LoadingDealFilterDropdown />;
    }*/

    return (
        <div id='deal-filter-dropdown' className='text-nowrap'>
            <div className='btn-group'>
                <div>
                    <button
                        ref={dropdownToggle}
                        type='button'
                        className='btn btn-outline-secondary border-0 mr-1 dropdown d-flex my-auto px-2 color-black'
                        onClick={() => setIsOpen((isOpen) => !isOpen)}>
                        <div className='d-flex align-items-center'>
                            {filterIcon}
                            <div className='mx-2'>{filterDescription}</div>
                            {getIcon('carret-down')}
                        </div>
                    </button>
                    {isOpen ? (
                        <div className='dropdown-menu py-2 pl-2 pr-1 d-block' ref={dropdown}>
                            {<FilterComponents type={type} t={t} />}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default DealFilterDropdown;

const LoadingDealFilterDropdown = ({ t }) => {
    return (
        <button
            type='button'
            className='btn btn-outline-secondary border-0 mr-1 dropdown d-flex align-items-center my-auto px-2 color-black crm-loader-wrapper'>
            {getIcon('filter')}
            <div className='invisible mx-2'>{t(FILTER_ITEM_ALLDEALS)}</div>
            {getIcon('carret-down')}
            <SpinLoader isLoading />
        </button>
    );
};
